import { render, staticRenderFns } from "./TeacherContactFormView.vue?vue&type=template&id=13c378b4&scoped=true"
import script from "./TeacherContactFormView.vue?vue&type=script&lang=js"
export * from "./TeacherContactFormView.vue?vue&type=script&lang=js"
import style0 from "./TeacherContactFormView.vue?vue&type=style&index=0&id=13c378b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c378b4",
  null
  
)

export default component.exports